// Blacklisted words

if (window.location.search !== "" && window.location.search !== "?") {
  const params = new URLSearchParams(window.location.search);

  let queries = {};

  for (var value of params.keys()) {
    queries[value] = params.get(value);
  }

  let blacklist_words = [
    "buy 15 likes",
    "buy instagram likes",
    "instagram likes for sale",
    "but instagram likes",
    "buy insta likes",
    "15 likes on instagram",
    "Twicsy Buy Instagram Likes",
  ];

  for (const [key, value] of Object.entries(queries)) {
    if (
      (/[^\x00-\x7F]+/.test(value) && key === "q") ||
      (/[^\x00-\x7F]+/.test(value) && key === "search_query") ||
      (/[^\x00-\x7F]+/.test(value) && key === "s") ||
      (blacklist_words.length && blacklist_words.includes(value))
    ) {
      window.location.href = window.location.href.split("?")[0];
    }
  }
}

jQuery(document).ready(function () {
  jQuery(document).on('click', ".product-thumbnail .thumbnail-swatch .swatch", function () {
    const currentSwatch = jQuery(this)
    currentSwatch.closest('.product-thumbnail').find('.custom-atc [name="id"]').val(currentSwatch.data('variantId'))
    currentSwatch.parent().find(".swatch").removeClass("active");
    currentSwatch.addClass("active");
    currentSwatch.closest('.product-thumbnail').find(".custom-atc").addClass("active");
    currentSwatch.parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('src', $(currentSwatch).data('variantImage'));
    currentSwatch.parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('srcset', $(currentSwatch).data('variantImage'));
  })
});

// Stock left

var divElements = document.querySelectorAll(".swatch-element");
var firstVariantStock = document.querySelector(".variant-title-stock");

// Hide all variant stocks except the first one
var allVariantStocks = document.querySelectorAll(".variant-title-stock");
if (allVariantStocks instanceof NodeList && allVariantStocks.length > 0) {
  allVariantStocks.forEach(function (stock) {
    stock.style.display = "none";
  });
}

firstVariantStock &&
  firstVariantStock.style &&
  (firstVariantStock.style.display = "block");

divElements.forEach(function (element) {
  element.addEventListener("click", function () {
    var dataValue = this.getAttribute("data-value");
    var variantStock = document.querySelector(
      '.variant-title-stock[data-variant="' + dataValue + '"]'
    );

    if (allVariantStocks instanceof NodeList && allVariantStocks.length > 0) {
      // Hide all variant stocks
      allVariantStocks.forEach(function (stock) {
        stock.style.display = "none";
      });
    }

    // Show the stock of the selected variant
    variantStock &&
      variantStock.style &&
      (variantStock.style.display = "block");
  });
});

$(document).ready(function () {
  $(".ambassador-section__inner").slick({
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img src=\"https://cdn.shopify.com/s/files/1/0991/4740/files/Path_10_1.svg?v=1732025793\" alt='Prev' /></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img src=\"https://cdn.shopify.com/s/files/1/0991/4740/files/Path_10.svg?v=1732025789\" alt='Next' /></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        },
      },
    ],
  });
});


// Homepage collection list slider
$(document).ready(function () {
  $(".custom-slider-container").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 2,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img src=\"https://cdn.shopify.com/s/files/1/0991/4740/files/Path_10_1.svg?v=1732025793\" alt='Prev' /></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img src=\"https://cdn.shopify.com/s/files/1/0991/4740/files/Path_10.svg?v=1732025789\" alt='Next' /></button>",
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});